import { render } from "./DS100IndividualCallMenu.vue?vue&type=template&id=b9ae3718&scoped=true"
import script from "./DS100IndividualCallMenu.vue?vue&type=script&lang=js"
export * from "./DS100IndividualCallMenu.vue?vue&type=script&lang=js"

import "./DS100IndividualCallMenu.vue?vue&type=style&index=0&id=b9ae3718&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ae3718"]])

export default __exports__